
import { component } from '@/helpers/vueTyped';
import store from '@/store';
import router from '@/router';
import { RawLocation } from 'vue-router';

interface WithNavigateOnFocusProps {
  to: RawLocation;
  disabled?: boolean;
}

export default component<WithNavigateOnFocusProps>()({
  name: 'WithNavigateOnFocus',

  props: {
    to: {},
    disabled: Boolean,
  },

  methods: {
    focused() {
      if (!this.disabled) {
        router.push(this.to).catch((err) => {
          if (err.from.name === err.to.name) {
            return;
          }

          throw err;
        });
      }
    },
  },

  render() {
    return (
      <router-link
        nativeOnFocus={this.focused}
        to={this.to}
        attrs={this.$attrs}
        tag='div'
      >
        {this.$slots.default}
      </router-link>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-6de911e2/WithNavigateOnFocus.vue" });